var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ slim: _vm.slim }},[_c('span',[_vm._t("default",function(){return [_vm._v("There is no content")]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }